import * as React from "react";
import classNames from "classnames";

import "./button.scss";

interface IButtonProps {
  [key: string]: any;
  tag?: React.ElementType;
  theme?: "primary" | "outline-primary" | "dark";
}

export const Button: React.FC<IButtonProps> = ({
  theme,
  className,
  tag: Tag = "button",
  ...props
}) => {
  const baseClassName = "button";
  className = classNames(
    baseClassName,
    {
      [`${baseClassName}--${theme}`]: theme
    },
    className
  );

  return <Tag className={className} {...props} />;
};
